/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, template: NonNullable<unknown> }} Uno_Confirm_Create_Project_From_Template_AdaptedInputs */



/**
* | output |
* | --- |
* | "Create the project “{name}” from the template “{template}”, with adapted instructions" |
*
* @param {Uno_Confirm_Create_Project_From_Template_AdaptedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_create_project_from_template_adapted = /** @type {((inputs: Uno_Confirm_Create_Project_From_Template_AdaptedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Create_Project_From_Template_AdaptedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt „${i?.name}“ aus der Vorlage „${i?.template}“ mit angepassten Anweisungen erstellen`)
	return /** @type {LocalizedString} */ (`Create the project “${i?.name}” from the template “${i?.template}”, with adapted instructions`)
});